export const AUTH_START = 'AUTH_START'
export const AUTH_END = 'AUTH_END'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_FAIL = 'AUTH_FAIL'
export const AUTH_CREDS = 'AUTH_CREDS'

// FRIENDS

export const FRIENDS_LOADING = 'FRIENDS_LOADING'
export const FRIENDS_ADD = 'FRIENDS_ADD'
export const FRIENDS_SELECT = 'FRIENDS_SELECT'
export const FRIENDS_ERROR = 'FRIENDS_ERROR'
export const FRIENDS_ENDLOADING = 'FRIENDS_ENDLOADING'
export const FRIENDS_LIST = 'FRIENDS_LIST'
export const FRIENDS_REMOVE = 'FRIENDS_REMOVE'
export const FRIENDS_SEARCH = 'FRIENDS_SEARCH'

export const FRIENDS_PENDING = 'FRIENDS_PENDING'
export const FRIENDS_CLEARCONFIRM = 'FRIENDS_CLEARCONFIRM'
export const FRIENDS_CANCEL_REQUEST = 'FRIENDS_CANCEL_REQUEST'
export const FRIENDS_MADE_REQUEST = 'FRIENDS_MADE_REQUEST'
export const FRIENDS_REJECT_REQUEST = 'FRIENDS_REJECT_REQUEST'

// GROUPS
export const GROUPS_FETCH = 'GROUPS_FETCH'
export const GROUPS_CREATE = 'GROUPS_CREATE'
export const GROUPS_LOADING = 'GROUPS_LOADING'
export const GROUPS_ENDLOADING = 'GROUPS_ENDLOADING'
export const GROUPS_SELECT = 'GROUPS_SELECT'
export const GROUPS_DESELECT = 'GROUPS_DESELECT'
export const GROUPS_ERROR = 'GROUPS_ERROR'
export const GROUPS_CREATING = 'GROUPS_CREATING'
export const GROUPS_DELETE = 'GROUPS_DELETE'

// RECEIPTS
export const RECEIPTS_FETCH = 'RECEIPTS_FETCH'
export const RECEIPTS_CREATE = 'RECEIPTS_CREATE'
export const RECEIPTS_LOADING = 'RECEIPTS_LOADING'
export const RECEIPTS_ENDLOADING = 'RECEIPTS_ENDLOADING'
export const RECEIPTS_SELECT = 'RECEIPTS_SELECT'
export const RECEIPTS_ERROR = 'RECEIPTS_ERROR'
export const RECEIPTS_CREATING = 'RECEIPTS_CREATING'
export const RECEIPTS_DELETE = 'RECEIPTS_DELETE'
export const RECEIPTS_STATS = 'RECEIPTS_STATS'
export const RECEIPTS_UPDATE = 'RECEIPTS_UPDATE'